"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefinedValues = exports.keysToSnakeCase = exports.keysToCamelCase = exports.transformObjectKeys = void 0;
var lodash_1 = require("lodash");
function transformObjectKeys(obj, trasformer) {
    if (trasformer === void 0) { trasformer = lodash_1.identity; }
    if ((0, lodash_1.isArray)(obj)) {
        return (0, lodash_1.map)(obj, function (val) { return transformObjectKeys(val, trasformer); });
    }
    if ((0, lodash_1.isPlainObject)(obj)) {
        return (0, lodash_1.reduce)(obj, function (acc, value, key) {
            acc[trasformer(key)] = transformObjectKeys(value, trasformer);
            return acc;
        }, {});
    }
    return obj;
}
exports.transformObjectKeys = transformObjectKeys;
function keysToCamelCase(obj) {
    return transformObjectKeys(obj, lodash_1.camelCase);
}
exports.keysToCamelCase = keysToCamelCase;
function keysToSnakeCase(obj) {
    return transformObjectKeys(obj, lodash_1.snakeCase);
}
exports.keysToSnakeCase = keysToSnakeCase;
function removeUndefinedValues(obj) {
    return (0, lodash_1.omitBy)(obj, lodash_1.isUndefined);
}
exports.removeUndefinedValues = removeUndefinedValues;
//# sourceMappingURL=object.js.map